<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

// Stable, vivid color palette keyed off the inbox id so each inbox gets
// a consistent badge color that's easy to spot in the conversation list.
const PALETTE = [
  { bg: 'rgb(34 197 94 / 0.18)', border: 'rgb(34 197 94 / 0.6)', text: 'rgb(21 128 61)' }, // green
  { bg: 'rgb(59 130 246 / 0.18)', border: 'rgb(59 130 246 / 0.6)', text: 'rgb(29 78 216)' }, // blue
  { bg: 'rgb(168 85 247 / 0.18)', border: 'rgb(168 85 247 / 0.6)', text: 'rgb(126 34 206)' }, // purple
  { bg: 'rgb(244 114 182 / 0.20)', border: 'rgb(244 114 182 / 0.6)', text: 'rgb(190 24 93)' }, // pink
  { bg: 'rgb(249 115 22 / 0.18)', border: 'rgb(249 115 22 / 0.6)', text: 'rgb(194 65 12)' }, // orange
  { bg: 'rgb(234 179 8 / 0.22)', border: 'rgb(234 179 8 / 0.6)', text: 'rgb(161 98 7)' }, // amber
  { bg: 'rgb(20 184 166 / 0.18)', border: 'rgb(20 184 166 / 0.6)', text: 'rgb(15 118 110)' }, // teal
  { bg: 'rgb(239 68 68 / 0.18)', border: 'rgb(239 68 68 / 0.6)', text: 'rgb(185 28 28)' }, // red
];

const swatch = computed(() => {
  const id = Number(props.inbox?.id) || 0;
  return PALETTE[Math.abs(id) % PALETTE.length];
});

const badgeStyle = computed(() => ({
  backgroundColor: swatch.value.bg,
  borderColor: swatch.value.border,
  color: swatch.value.text,
}));
</script>

<template>
  <div
    :title="inbox.name"
    :style="badgeStyle"
    class="inline-flex items-center gap-1 min-w-0 px-1.5 py-0.5 rounded-md border max-w-full"
  >
    <ChannelIcon :inbox="inbox" class="size-3.5 flex-shrink-0" />
    <span class="truncate text-label-small leading-none font-medium">
      {{ inbox.name }}
    </span>
  </div>
</template>
